import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';

const LOADING_SPINNER_SIZE_MEDIUM = 90;
const LOADING_SPINNER_SIZE_SMALL = 50;

const LoadingSpinner = ({ size = LOADING_SPINNER_SIZE_MEDIUM, }) => {
    const [spinnerSrc, setSpinnerSrc] = useState(null);
    useEffect(() => {
        const loadSpinnerImage = async () => {
            if (size <= 0 || size > LOADING_SPINNER_SIZE_MEDIUM) {
                return;
            }
            setSpinnerSrc(size > LOADING_SPINNER_SIZE_SMALL
                ? (await import('./spinner-medium-CnoeGAAv.js')).default
                : (await import('./spinner-small-D_6LaQpN.js')).default);
        };
        loadSpinnerImage();
    }, [size]);
    return (spinnerSrc && (jsx("img", { alt: "Spinning ring of red dots", height: size, src: spinnerSrc, width: size })));
};

export { LoadingSpinner as L, LOADING_SPINNER_SIZE_MEDIUM as a, LOADING_SPINNER_SIZE_SMALL as b };
//# sourceMappingURL=component-Bc-6q0i_.js.map
